import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ProblemSection from './components/ProblemSection';
import AboutUs from './components/AboutUs';
import OurServices from './components/OurServices';
import SpecializedSolutions from './components/SpecializedSolutions';
import HowWeWork from './components/HowWeWork';
import RecentWorks from './components/RecentWorks';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';

export default function ZenruvaLanding() {
  const [activeStep, setActiveStep] = useState('discover');
  const [activeFAQ, setActiveFAQ] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [skeletonPhase, setSkeletonPhase] = useState(0);

  useEffect(() => {
    setIsLoaded(true);

    // Skeleton animation phases
    const interval = setInterval(() => {
      setSkeletonPhase(prev => (prev + 1) % 3);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-3 md:p-4">
      {/* Main Container with white background and rounded corners */}
      <div className="mx-auto bg-white rounded-[24px] md:rounded-[32px] shadow-xl">
        {/* Blue gradient section */}
        <div className="bg-gradient-to-b from-[#0054DB] to-[#4284ED] overflow-hidden rounded-[24px] md:rounded-[32px]">
          <Header isLoaded={isLoaded} />
          <HeroSection isLoaded={isLoaded} skeletonPhase={skeletonPhase} />
        </div>

        <ProblemSection />

        <StatsSection />

        <div id="about-us">
          <AboutUs />
        </div>

        <div id="our-service">
          <OurServices />
        </div>

        <SpecializedSolutions />

        <HowWeWork activeStep={activeStep} setActiveStep={setActiveStep} />

        <div id="work">
          <RecentWorks />
        </div>

        <FAQ activeFAQ={activeFAQ} setActiveFAQ={setActiveFAQ} />

        <CTASection />

        <ContactForm />

        <Footer />
      </div>
    </div>
  );
}